import {
  collection, getDocs, query, where,
} from 'firebase/firestore';
import { db } from '../firebase';

import { C_STORIES } from '../../constants/collections';
export interface Story {
  id: string;
  cats: string[];
  heat: number;
  title: string;
  source: string;
  date: string;
  summary: string;
  relevance: string;
  angles: { id: string; icon: string; title: string; desc: string }[];
  alert?: boolean;
  alertAt?: string;
  weekOf?: string;
  fetchedAt?: string;
}

const storiesCol = () => collection(db, C_STORIES);

function getMondayOfWeek(): string {
  const d = new Date();
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);
  return d.toISOString().split('T')[0];
}

/** Get digest stories — current week first, falls back to all. Sort by heat client-side. */
export async function getDigestStories(): Promise<Story[]> {
  const weekOf = getMondayOfWeek();

  // Try current week (single equality filter — no composite index needed)
  let snap = await getDocs(
    query(storiesCol(), where('weekOf', '==', weekOf)),
  );

  // Fallback to all stories if current week is empty
  if (snap.empty) {
    snap = await getDocs(query(storiesCol()));
  }

  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() } as Story))
    .sort((a, b) => b.heat - a.heat);
}
